import { Pipe, PipeTransform, inject } from '@angular/core';

import { ResourcesService } from '@mitsubishi/core';
import { Accessory } from '@mitsubishi/shared/data-access';

import { Nullable } from '@angular-ru/cdk/typings';
import { isNil } from '@angular-ru/cdk/utils';

@Pipe({
  name: 'apmAccessoryName',
  standalone: true,
})
export class ApmAccessoryNamePipe implements PipeTransform {
  #resourceService = inject(ResourcesService);

  transform(value: Nullable<Accessory>): string {
    if (isNil(value)) {
      return '-';
    }

    return value.name ?? this.#resourceService.getTextResource(value.resourceId);
  }
}
